import CreateNewAudiencesModal from './CreateSeedAudiencesModal.Container';

export default CreateNewAudiencesModal;
